<template>
  <div class="player-controls">
    <div class="control-btn playlist-btn" @click="$emit('playlist')">
      <img src="@/assets/walkman/ic-list.png" />
    </div>
    <div
      class="control-btn prev-btn"
      :class="{ disabled: prevDisabled }"
      @click="handlePrevClick"
    >
      <img :src="prevDisabled ? disabledPrevIcon : normalPrevIcon" />
    </div>
    <div class="control-btn play-btn" @click="$emit('play-pause')">
      <img :src="playIcon" />
    </div>
    <div
      class="control-btn next-btn"
      :class="{ disabled: nextDisabled }"
      @click="handleNextClick"
    >
      <img :src="nextDisabled ? disabledNextIcon : normalNextIcon" />
    </div>
    <div class="control-btn hide-btn" @click="$emit('hide')">
      <img :src="hideIcon" />
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps, defineEmits } from "vue";

const props = defineProps({
  showPlayerView: {
    type: Boolean,
    default: false,
  },
  isPlaying: {
    type: Boolean,
    default: false,
  },
  // 列表未加载完时，禁用“上一首/跳到末尾”按钮
  prevDisabled: {
    type: Boolean,
    default: false,
  },
  // 下一页没加载出来时，禁用“下一首”按钮
  nextDisabled: {
    type: Boolean,
    default: false,
  },
});
    
const emit = defineEmits([
  "playlist",
  "prev",
  "play-pause",
  "next",
  "hide",
  "next-disabled",
]);
    
const hideIcon = computed(() => {
  return props.showPlayerView
    ? require("@/assets/walkman/ic-close-eye.png")
    : require("@/assets/walkman/ic-eye.png");
});

const playIcon = computed(() => {
  return props.isPlaying
    ? require("@/assets/walkman/ic-stop.png")
    : require("@/assets/walkman/ic-play.png");
});

const normalPrevIcon = computed(() => require("@/assets/walkman/ic-last.png"));
const disabledPrevIcon = computed(() => require("@/assets/walkman/ic-pre.png"));
const normalNextIcon = computed(() => require("@/assets/walkman/ic-next.png"));
const disabledNextIcon = computed(() => require("@/assets/walkman/ic-next1.png"));

const handlePrevClick = () => {
  if (props.prevDisabled) return;
  emit("prev");
};

const handleNextClick = () => {
  if (props.nextDisabled) {
    emit("next-disabled");
    return;
  }
  emit("next");
};
</script>

<style scoped lang="scss">
.player-controls {
  position: fixed;
  bottom: 73px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;

  .control-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #333333;
    transition: opacity 0.3s;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -webkit-tap-highlight-color: transparent;
  }
}

.playlist-btn {
  width: 21px;
  height: 17px;
  img {
    width: 100%;
    height: 100%;
  }
}
.prev-btn,
.next-btn {
  width: 23px;
  height: 19px;
  img {
    width: 100%;
    height: 100%;
  }
}

.prev-btn {
  margin-left: 55px;
}
.prev-btn.disabled {
  opacity: 0.45;
  pointer-events: none;
}
.next-btn.disabled {
  opacity: 0.45;
}
.next-btn {
  margin-right: 55px;
}
.play-btn {
  width: 44px;
  height: 44px;
  margin: 0 36px;
  img {
    width: 100%;
    height: 100%;
  }
}
.hide-btn {
  width: 23px;
  height: 23px;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>

